export const HANDLED_STRIPE_EVENT_TYPES = [
  'checkout.session.completed',
  'invoice.paid',
  'invoice.payment_succeeded',
  'invoice.payment_failed',
  'invoice_payment.paid',
  'customer.subscription.created',
  'customer.subscription.deleted',
  'customer.subscription.updated',
] as const;

export type HandledStripeEventType = (typeof HANDLED_STRIPE_EVENT_TYPES)[number];

export const STRIPE_SUBSCRIPTION_STATUSES = [
  'active',
  'past_due',
  'unpaid',
  'canceled',
  'incomplete',
  'incomplete_expired',
  'trialing',
  'paused',
] as const;

export type StripeSubscriptionStatus = (typeof STRIPE_SUBSCRIPTION_STATUSES)[number];

export const STRIPE_TRANSACTION_STATUSES = ['succeeded', 'failed', 'pending', 'requires_action'] as const;

export type StripeTransactionStatus = (typeof STRIPE_TRANSACTION_STATUSES)[number];
